import React, { useState, useEffect } from 'react';
import { HashLink } from 'react-router-hash-link';
import NavLinks from '../Navbar/NavLinks';
import Logo from '../../images/logo.png';

const NavBar = () => {
    const [scrolled, setScrolled] = useState(window.scrollY > 10);
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = () => setIsOpen((prev) => !prev);
    const closeMenu = () => setIsOpen(false);

    useEffect(() => {
        const scrollHandler = () => setScrolled(window.pageYOffset > 10);
        window.addEventListener('scroll', scrollHandler);
        return () => window.removeEventListener('scroll', scrollHandler);
    }, []);

    return (
        <nav
            className={`fixed top-0 left-0 w-full z-40 bg-brand transition-all duration-300 ease-in-out ${
                scrolled ? 'shadow-nav bg-brand/95 backdrop-blur-sm py-2' : 'py-3'
            }`}
        >
            <div className="container-app flex items-center justify-between">
                <HashLink smooth to="/" className="flex items-center gap-2.5 shrink-0" onClick={closeMenu}>
                    <img
                        src={Logo}
                        alt="PT Berani Setia Waspada"
                        className="h-9 w-9 rounded-full bg-white/10 object-contain p-1"
                    />
                    <span className="text-white font-semibold text-sm sm:text-base leading-tight">
                        PT Berani Setia Waspada
                    </span>
                </HashLink>

                <div className="hidden lg:flex items-center space-x-1">
                    <NavLinks />
                </div>

                <button
                    type="button"
                    className="lg:hidden inline-flex items-center justify-center h-11 w-11 rounded-lg text-white hover:bg-white/10 transition-colors duration-200 cursor-pointer"
                    onClick={handleClick}
                    aria-label={isOpen ? 'Tutup menu' : 'Buka menu'}
                    aria-expanded={isOpen}
                >
                    <svg className="h-6 w-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        {isOpen ? (
                            <path fillRule="evenodd" clipRule="evenodd" d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z" />
                        ) : (
                            <path fillRule="evenodd" d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z" />
                        )}
                    </svg>
                </button>
            </div>

            <div
                className={`lg:hidden absolute left-0 top-full w-full bg-white shadow-xl overflow-hidden transition-all duration-300 ease-in-out ${
                    isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0 pointer-events-none'
                }`}
            >
                <div className="flex flex-col items-center gap-1 py-6" onClick={closeMenu}>
                    <NavLinks />
                </div>
            </div>
        </nav>
    )
}

export default NavBar;
